// CSS
import "./styles/global.scss";

// JS
import $ from "jquery";
import initComponents from "./component-loader.js";

// Adding ES module initialisation for components
initComponents();

// Duetds (datepicker): https://github.com/duetds/date-picker
import { DuetDatePicker } from "@duetds/date-picker/custom-element";
customElements.define("duet-date-picker", DuetDatePicker);

window.jQuery = window.$ = $;
require("jquery-validation");
require("datatables.net");
require("prismjs");
require("flatpickr");
import Bloodhound from "corejs-typeahead/dist/bloodhound.js";
window.Bloodhound = Bloodhound;
require("corejs-typeahead/dist/typeahead.jquery.js");
require("./externals/funnelback.autocompletion-2.6.0.js");

// Import the index file from core (loads + initialises the remaining components)
import "@qhealth-design-system/core/src/index.js";

// Local (extended) component behaviours — not provided by core.
import "./components/_global/js/user_location/global.js";
import "./components/_global/js/forms/global.js";
